export class SocketMessage {
    type: SocketMessageType
    message: string
    value: string | null
    action1Url: string | null
    action1Text: string | null
    whatsappMessageId: number;
}

export enum SocketMessageType {
    CreateIncident = 1,
    UpdateIncident = 2,
    InfoMessage = 3,
    ErrorMessage = 4,
    WarningMessage = 5,
    WhatsappIncident = 6,
    WhatsappOther = 7,
    ProofOfWorkDocument = 8,
    IncidentLocationUpdate = 9,
    IncidentETAUpdate = 10,
    ServiceProviderStatusUpdate = 11,
    ServiceProviderRejected = 12,
    BDTechComplete = 13,
    BDTechAccepted = 14,
    WhatsappMessageLinked = 15,
    IncidentChatMessageCreated = 16,
    IncidentChatMessageEscalated = 17,
    IncidentChatMessageEscalationAcknowledgement = 18,


}
